// @givmo/app-admin — the Settings tab strip's scroll lane (EP-WEB17).
//
// Five one-line tabs need ~567px and a 390px phone leaves a 342px lane, so the strip is a sideways
// scroll lane rather than the page. A lane can leave the ACTIVE tab — and so its indicator — outside
// its visible window: a deep-linked tab (the SSO ceremony returns to `?tab=security`) renders past a
// phone's edge. This is the one piece of arithmetic that brings it back, kept pure so it is testable
// without a layout engine.

/** A tab's box along the lane: `offsetLeft` / `offsetWidth` against the lane (its offset parent). */
export interface LaneTab {
  offsetLeft: number;
  offsetWidth: number;
}

/** The lane's visible window: how far it is scrolled, and how wide it is. */
export interface LaneWindow {
  scrollLeft: number;
  clientWidth: number;
}

/**
 * The lane `scrollLeft` that brings the tab fully into view with the least movement, or `null` when
 * it is already fully visible. A tab wider than the lane aligns its start.
 */
export function laneScrollToReveal(tab: LaneTab, lane: LaneWindow): number | null {
  const start = tab.offsetLeft;
  const end = start + tab.offsetWidth;
  const visibleEnd = lane.scrollLeft + lane.clientWidth;
  if (start >= lane.scrollLeft && end <= visibleEnd) return null;
  if (start < lane.scrollLeft || tab.offsetWidth >= lane.clientWidth) return start;
  return end - lane.clientWidth;
}
